import { reactive, ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as apiInquiry from '@/api/inquiry'
import * as common from '@/util/common'
import * as CommonInquiry from '@/logic/common/CommonInquiry'

/**
 * 入力画面
 */
export const getGroupIndex = () => {

  const group1 = reactive({
    // フォーム入力値
    message_type: '',
    message: '',

    // 入力エラーフラグ
    isError: false,

    // フォーム入力エラーメッセージ
    error_message_type: '',
    error_message: '',

    isVisibleTypeList: false,
    listTypeItem: [
      {
        value: 0, 
        label: '選択してください'
      },
      {
        value: 1, 
        label: 'ご契約の変更・追加について'
      },
      {
        value: 2, 
        label: 'ご利用方法について'
      },
      {
        value: 3, 
        label: 'コンテンツの内容について'
      },
      {
        value: 5, 
        label: '自動決済について'
      },
      {
        value: 4, 
        label: 'その他について'
      }
    ],

    // 送信中フラグ（二重送信防止用）
    isProcessing: false,

    /**
     * 初期表示
     */
    init: () => {
      // ストアからデータをロード
      group1.message_type = store.state.inquiry.message_type ?? ''
      group1.message = store.state.inquiry.message ?? ''
    },

    /**
     * お問い合わせタイプが選択された場合 → お問い合わせタイプ一覧を表示する
     */
    onTypeListSelected: (selectedName) => {

      // 表示していたプルダウンリストを非表示にする
      group1.isVisibleTypeList = false

      // 選択したお問い合わせタイプをプルダウンに表示
      group1.message_type = selectedName
  
      if (selectedName === 'コンテンツの内容について') {
        group1.message = '書 籍 名：\n該当箇所：\nお問い合わせ内容をご入力ください。'
      } else {
        group1.message = ''
      }
    },

    /**
     * 次へボタンを押下した時
     */
    submitButtonClicked: () => {
  
      // 入力チェック
      const actionAfterCompletion = (group1, isError) => {
    
        group1.isError = isError

        if (group1.isError) {
          // 入力エラーが存在した場合
          return false
        }

        // Vuexに入力値を保持
        store
          .dispatch('inquiry/setFormInputValues', {
            message_type: group1.message_type,
            message: group1.message
          })

        if (store.state.common.device === 'sp') {
          router.push({ path: '/sp/inquiry-confirm' })
        } else {
          router.push({ path: '/pc/inquiry-confirm' })
        }

      }
      CommonInquiry.checkInput(group1, actionAfterCompletion)
    }
  })

  return group1
}

/**
 * 確認画面
 */
export const getGroupConfirm = () => {

  const group1 = reactive({
    // フォーム入力値
    message_type: '',
    message: '',
    messageDisp: computed(() => {
      let value = group1.message
      value = common.escapeHTML(value)
      return value.replace(/\r?\n/g, '<br>')
    }),

    /**
     * 初期表示
     */
    init: () => {
      // ストアからデータをロード
      group1.message_type = store.state.inquiry.message_type ?? ''
      group1.message = store.state.inquiry.message ?? ''

      if (group1.message === '') {
        if (store.state.common.device === 'sp') {
          router.push({ path: '/sp/inquiry-input' })
        } else {
          router.push({ path: '/pc/inquiry-input' })
        }
      }
    },

    /**
     * 確定ボタンクリック時
     */
    onSubmitButtonClicked: () => {

      // 二重送信防止
      if (group1.isProcessing) {
        const payload = {
          title: '二重送信エラー',
          text: '短い時間に複数回送信ボタンが押されました。\n二重送信の可能性があるため、2度目以降の処理を中断します。'
        }
        store.dispatch('common/showNotice', payload)
        return
      }

      // 送信中フラグ（二重送信防止用）をtrueに設定
      group1.isProcessing = true

      // 画面リロードにより入力データが消えた場合に登録できないようにする。
      // 入力チェック
      const actionAfterCompletion = (group1, isError) => {

        if (isError) {
          // 入力エラーが存在した場合

          store.dispatch('common/showNotice', { title: 'エラー', text: '入力データが設定されていません。' })
          return false
        }

        // お問い合わせ登録APIをコール
        const params = {
          message_type: group1.message_type,
          message: group1.message
        }

        store.dispatch('common/showLoading')
        apiInquiry.registerInquiry(params)
          .then(response => {
            // お問い合わせ登録APIのレスポンスを取得
            if (response) {
              const { data } = response

              if (data) {
                const status = data.status ?? -1

                if (status === 0) {
                  // status=0: 成功
                  if (store.state.common.device === 'sp') {
                    router.push({ path: '/sp/inquiry-complete' })
                  } else {
                    router.push({ path: '/pc/inquiry-complete' })
                  }
                } else {
                  // status=その他: エラーダイアログを表示
                  store.dispatch('common/showNotice', { title: 'エラー', text: response.data.error_message })
                }
              }
            }
          })
          .finally(() => {
            // 送信中フラグ（二重送信防止用）をfalseに設定
            group1.isProcessing = false

            store.dispatch('common/hideLoading')
          })

      }
      CommonInquiry.checkInput(group1, actionAfterCompletion)
    }
  })

  return group1
}

/**
 * 完了画面
 */
export const getGroupComplete = () => {

  const group1 = reactive({

    /**
     * 初期表示
     */
    init: () => {

      // ストアに保持している値を全クリア
      store.dispatch('inquiry/clearAllStates')
    }
  })

  return group1
}
